import { Dispatch, SetStateAction } from 'react';

import { css } from '@compiled/react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useAiSearchEnabled } from '@/utils/search/use-ai-search-enabled';

import SearchButton from './search-button';

export type NavSearchActionProps = {
	isShowSearchButton?: boolean;
	showAiBackground?: boolean;
	setIsOpenSearch: Dispatch<SetStateAction<boolean>>;
};

export const NavSearchAction = ({
	isShowSearchButton = true,
	showAiBackground = true,
	setIsOpenSearch,
}: NavSearchActionProps) => {
	const aiEnabled = useAiSearchEnabled();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return (
		<div
			css={css({
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			})}
		>
			{isShowSearchButton && (
				<SearchButton
					buttonId={'global-nav-search-bar-icon-desktop'}
					aiEnabled={aiEnabled}
					showAiBackground={showAiBackground}
					onClick={(e) => {
						e.preventDefault();
						setIsOpenSearch(true);

						createAnalyticsEvent({
							eventName: 'searchOpen',
							eventType: 'ui',
							action: 'clicked',
							actionSubject: 'button',
							actionSubjectId: 'searchButtonDesktop',
							source: 'globalNav',
							attributes: {
								product: 'search',
								pageUrl: window.location.href,
								pagePath: window.location.pathname,
								aiEnabled: aiEnabled,
							},
						}).fire();
					}}
				/>
			)}
		</div>
	);
};
